module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-cover-5-a5a3a3677459695549dcc2bc65d600ab.jpg";